/**
 * Where the animal atlases are and how they are cut up.
 *
 * **Four numbers in a file of their own, and the file exists for a boring reason worth writing
 * down.** They have to be readable by two callers with nothing else in common: the renderer, which
 * needs the DOM and Pixi, and the test that checks the sheets on disk really are this grid, which
 * runs under Node with no DOM at all (`tsconfig.scripts.json` compiles tests without the DOM lib on
 * purpose). Importing the renderer from the test dragged Pixi, `paint.ts` and the audio context
 * into a Node compile and failed on `document`.
 *
 * They must match `apps/web/scripts/make-animal-atlas.py`, which writes the sheets. Nothing in the
 * type system connects a Python constant to a TypeScript one, so `shadow-card.test.ts` reads the
 * image headers and asserts it instead.
 */

/**
 * WebP rather than PNG, and it is a quality decision before it is a size one.
 *
 * The sheets used to be PNGs squeezed through a 128-entry palette, which quantises the ALPHA along
 * with the colour — 41 opacity levels where the cut-out has 256. Every outline came out a staircase
 * and every flat fill broke into speckle. Full RGBA PNG fixes it and costs 838 KB; WebP fixes it at
 * 184, keeps its alpha channel lossless even in lossy mode, and is supported everywhere this app
 * runs (the Android shell is a TWA over Chrome).
 */
export const COLOUR_ATLAS = "/images/animals-colour.webp";
export const SHADOW_ATLAS = "/images/animals-shadow.webp";

/**
 * One animal to a cell, this many pixels square.
 *
 * 208 so that nothing is enlarged on the way in: the largest drawing on the source sheets is 189 px
 * on its long edge, and 208 less two 9 px margins is 190. The screen still magnifies — a target
 * card on a 360 px phone is about 166 CSS px, or 332 physical at devicePixelRatio 2 — and no atlas
 * size can fix that, because the artwork does not contain the pixels. What this avoids is doing it
 * TWICE, once with LANCZOS here and again with the GPU's bilinear at draw time.
 */
export const ATLAS_CELL = 208;
/** Cells across. The roster fills rows left to right, so the row count follows from the count. */
export const ATLAS_COLS = 6;
